import Constants from '../../constants';

export default {
  lang: {
    current: Constants.GLOBAL_KEYS.DEFAULT_LANG,
    status: Constants.GLOBAL_KEYS.STATUS.INITIAL
  },
};



// WEBPACK FOOTER //
// ./src/stores/lang/_state.js